const rawMaterialMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Raw Material Type',
        accessor: 'materialtype',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Raw Material Id',
        accessor: 'materialcode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Name',
        accessor: 'materialname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Description',
        accessor: 'materialdescription',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default rawMaterialMasterColumns;
